import {
  React,
  Component,
  helpers,
} from 'imports/CommonImports';

import {
  PrimaryColor1Light,
  GreyColor1,
} from 'imports/DesignImports';

import {
  DoneIcon,
} from 'imports/IconsImports';

import {
  Paper,
} from 'material-ui';

const styles = {
  conventionsContainer: {
    backgroundColor:  PrimaryColor1Light,
    color: '#FFFFFF',
    display: 'flex',
    padding: '0 1em 1em 1em',
  },
  definitionContainer: {
    flex: 3,
  },
  conventionContainer: {
    flex: 2,
    margin: '0 0.5em',
  },
  innovationDefinition:{
    color: GreyColor1,
    fontWeight: '100',
    maxHeight: '6em',
    overflowY: 'scroll',
  },
  text: {
    color: GreyColor1,
    fontWeight: '100',
  },
  header: {
    color: '#FFFFFF',
    fontWeight: '300',
  }
}

class CompanyConventions extends Component {

  render() {
    let rawConventions = this.props.companyConventions;
    let conventions = helpers.groupBy(rawConventions, rawConventions => rawConventions.filter__name, rawConventions => rawConventions.option__name)
    return(
      <Paper style={styles.conventionsContainer}>
        <div style={styles.definitionContainer}>
          <p style={styles.header}>¿Qué es innovación para tu empresa?</p>
          <div className="p2" style={styles.innovationDefinition}>{this.props.innovationDefinition}</div>
        </div>
        {Object.keys(conventions).map((key) => {
          return(<div key={key} style={styles.conventionContainer}>
            <p style={styles.header}>{key}</p>
            {conventions[key].map((convention) => {
              return(
                <div className="p2" key={convention} style={styles.text}> <DoneIcon style={styles.text}/> {convention}</div>
              )
            })}
          </div>
        )
        })}
      </Paper>
    )
  }
}

export default CompanyConventions;



// WEBPACK FOOTER //
// ./src/components/postulation/CompanyConventions.js